import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"delete\"><path d=\"M5 6H4V4h4.5l1-1h5l1 1H20v2h-1v12.857C19 20.036 17.95 21 16.667 21H7.333C6.05 21 5 20.036 5 18.857zm12 0H7v13h10zM9 8h2v9H9zm4 0h2v9h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol